/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';
import { ConsoleBaseInstance } from '../Base/ConsoleBaseInstance.entity';
import {
  CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_CANARY,
  CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_DEDICATED,
  CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_DEVELOPMENT,
  CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_EVALUATION,
  CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_INTERNAL,
  CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_PRODUCTION,
} from './types/ConsoleInstanceMatrixEnvironmentType.types';
import {
  CONSOLE_INSTANCE_MATRIX_HOSTING_TYPE_DEDICATED,
  CONSOLE_INSTANCE_MATRIX_HOSTING_TYPE_SAAS,
} from './types/ConsoleInstanceMatrixHostingType.types';

export type EntityConsoleMatrixInstance = io.TypeOf<typeof ConsoleMatrixInstance>;

export const ConsoleMatrixInstance = io.intersection([
  ConsoleBaseInstance,
  io.type({
    adminUrl: io.string,
    environment: io.union([
      io.literal(CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_PRODUCTION),
      io.literal(CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_DEVELOPMENT),
      io.literal(CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_EVALUATION),
      io.literal(CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_INTERNAL),
      io.literal(CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_CANARY),
      io.literal(CONSOLE_INSTANCE_MATRIX_ENVIRONMENT_TYPE_DEDICATED),
    ]),
    hostingType: io.union([
      io.literal(CONSOLE_INSTANCE_MATRIX_HOSTING_TYPE_DEDICATED),
      io.literal(CONSOLE_INSTANCE_MATRIX_HOSTING_TYPE_SAAS),
    ]),
    systemName: io.string,
  }),
]);
